import { usePageTitle } from "../../hooks"
import animationEmail from "../../assets/animation/email.json"
import { Grid, Typography } from "@mui/material";
import Lottie from "react-lottie";

export const EmailSended = () => {
    usePageTitle("E-mail de recuperação enviado")

    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationEmail,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return (
        <Grid
            container
            sx={{
                height: "calc(100% - 80px)",
                display: "flex",
                gap: "2rem",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingBottom: "20px",
                flexWrap: "nowrap"
            }}
        >
            <div style={{ width: 240, height: 240 }}>
                <Lottie options={defaultOptions} />
            </div>
            <Typography variant="h1">E-mail enviado</Typography>

            <Typography variant="body1" textAlign={"center"} sx={{ opacity: 0.5 }}>Acesse o e-mail que acabamos de enviar para você e clique no link para criar uma nova senha.</Typography>

        </Grid>
    )

}